import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormControl} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {UsersAnagrafService} from '../../../general-services/service-users-anagraf/users-anagraf.service';

@Component({
  selector: 'app-user-role-filter',
  templateUrl: './user-role-filter.component.html',
  styleUrls: ['./user-role-filter.component.scss']
})
export class UserRoleFilterComponent extends ProjectConstants implements OnInit, OnDestroy {

  listFilterRoles: any[];
  rolesFormControl = new FormControl();
  rolesFilteredOptions: Observable<any[]>;

  getAllUsers: Subscription;


  @Output() dataFiltered = new EventEmitter<any>();

  constructor(private usersService: UsersAnagrafService) {
    super();
  }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.listFilterRoles = [];
    for (let i = 0; i <= this.ROLES_LIST.length; i++) {
      this.listFilterRoles.push({'id': i + 1, 'role': this.ROLES_LIST[i]});
    }

    this.rolesFormControl.setValue(null);
  }

  reset() {
    this.rolesFormControl.setValue(null);
  }


  ngOnDestroy(): void {
  }

}
